import { CSSProperties, FC, ReactNode } from 'react'
import errorIcon from '../../images/icons/error-icon.svg'

interface BaseErrorProps {
  onClose: () => void
  header: string
  message: ReactNode
}

const BaseError: FC<BaseErrorProps> = ({ onClose, header, message }) => {
  const errorStyle: CSSProperties = {
    backgroundColor: '#fdeded',
    padding: '10px 10px 10px 40px',
    marginTop: '10px',
    textAlign: 'left',
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  }

  const iconStyle: CSSProperties = {
    position: 'absolute',
    left: '10px',
    top: '10px',
    width: '20px',
    height: '20px',
  }

  const closeButtonStyle: CSSProperties = {
    position: 'absolute',
    right: '10px',
    top: '10px',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: '0',
    outline: 'none',
    fontSize: '20px',
  }

  const headerStyle: CSSProperties = {
    fontWeight: 'bold',
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  }

  const messageStyle: CSSProperties = {
    marginTop: '5px',
  }

  return (
    <div style={errorStyle}>
      <img src={errorIcon} alt="Error" style={iconStyle} />
      <div style={headerStyle}>
        <span>{header}</span>
        <button style={closeButtonStyle} onClick={onClose} aria-label="Close">
          &times;
        </button>
      </div>
      <span style={messageStyle}>{message}</span>
    </div>
  )
}

export default BaseError
